import { type IDataCrew } from "~~/types/liveTracking/crew.interface";
import { useCrew } from "../stores/useCrewStore";
import { getStatusText } from "~~/constant/StatusCodes";
import { LOCAL_STORAGE_KEY } from "~~/constant/tracking.constant";

export interface IProcessedCrewData extends IDataCrew {
    displayCrewStatus: string
}

const { crewsData, fetchTripByNikCrew, fetchCrew } = useCrew()
const { setLastUpdate, showBadgeWithReset, lastUpdate } = useUpdateBadge()
const { member } = useMember()
const selectedCrew = ref<boolean>(false);
const activeCard = ref<string>()
const selectedCrewData = ref<IProcessedCrewData | null>(null);

export const useCrewTracking = () => {

    const searchCrew = ref<string>("");
    const selectedStatus = ref("All");
    const isClearBtn = ref<boolean>(false)


    // SECTION Computed
    const crews = computed<IProcessedCrewData[]>(() => {
        if (!crewsData.value || !crewsData.value.crews) {
            return [];
        }

        if (searchCrew.value.length > 0 && searchCrew.value.length < 3) {
            return [];
        }

        return crewsData.value.crews.map(apiCrew => ({
            ...apiCrew,
            displayCrewStatus: getStatusText(apiCrew.status ?? 0)
        }));
    });

    //ANCHOR Search Crew Toko
    const filteredCrews = computed(() => {
        let currentFilteredCrew: IProcessedCrewData[] = crews.value;

        if (selectedStatus.value !== "semua") {
            const statusMapping: Record<string, number[]> = {
                "available": [301],
                "sedang mengirim": [302],
                "transit": [303],
                "kembali ke toko": [304],
            };
            const targetStatuses = statusMapping[selectedStatus.value];

            if (targetStatuses) { // Pastikan targetStatuses ada
                currentFilteredCrew = currentFilteredCrew.filter(crew =>
                    targetStatuses.includes(crew.status ?? 0)
                );
            }
        }

        if (searchCrew.value && searchCrew.value.length >= 3) {
            const lowerCaseQuery = searchCrew.value.toLowerCase();
            currentFilteredCrew = currentFilteredCrew.filter((crew) => {
                const crewName = crew?.name.toLowerCase() || "";
                return crewName.includes(lowerCaseQuery);
            });
        } else if (searchCrew.value && searchCrew.value.length < 3) {
            return [];
        }
        return currentFilteredCrew;
    });

    const _searchCrew = computed({
        get: () => searchCrew.value,
        set: (newValue: string) => {
            searchCrew.value = newValue.toUpperCase();
        }
    });

    const handleFilter = () => {
        const params: Record<string, any> = {
            storeCode: member.value?.storeCode
        };

        // PENTING: Tambahkan kondisi untuk filter yang tidak kosong
        // if (searchCrew.value && searchCrew.value.length >= 3) {
        //     params.search = searchCrew.value;
        // }

        if (selectedStatus.value !== "All") {
            params.status = selectedStatus.value;
        }
        fetchCrew(params);
    };

    watch([selectedStatus], () => {
        handleFilter();

        if (searchCrew.value.length > 0) {
            isClearBtn.value = true
        }
        if (searchCrew.value.length === 0) {
            isClearBtn.value = false
        }

    }, { deep: true });
    watch(searchCrew, () => {
        isClearBtn.value = searchCrew.value.length > 0
    })

    watch([filteredCrews, selectedCrewData], ([newFiltered, newSelected]) => {

        const findCrewInFiltered = newFiltered.some(crew => crew.nik === newSelected?.nik)

        if (newFiltered.length === 0) {
            selectedCrew.value = false
            activeCard.value = ''
        }

        if (!findCrewInFiltered) {
            selectedCrew.value = false
            activeCard.value = ''

        }
    })

    // SECTION Event
    const handleSelectCrew = (crew: IProcessedCrewData) => {
        activeCard.value = crew.nik
        selectedCrewData.value = crew;
        selectedCrew.value = true
        fetchTripByNikCrew(crew)
    };

    const btnClearSearch = () => {
        searchCrew.value = ""
    }

    const handleUpdateStatus = async () => {
        fetchCrew({ storeCode: member.value?.storeCode })
        if (!selectedCrewData.value) {
            return
        }
        await fetchTripByNikCrew(selectedCrewData.value)
        lastUpdate.value =
            setLastUpdate(LOCAL_STORAGE_KEY.TrackingCrew)

        showBadgeWithReset()
    }

    return {
        handleSelectCrew,
        crews: filteredCrews,
        totalCrew: computed(() => crewsData.value?.totalCrew),
        selectedCrew,
        activeCard,
        _searchCrew,
        // filteredCrews,
        searchCrew,
        selectedStatus,
        selectedCrewData,
        btnClearSearch,
        isClearBtn,
        handleUpdateStatus
    }
}